import { normalizeCanonicalUrl } from '@/seo/canonical';
import { FormattedDate } from '../FormattedDate';

type Props = {
  slug: string;
  heroImage?: string | null;
  heroImageAlt?: string | null;
  title: string;
  description: string;
  authorImage?: string | null;
  author: string;
  pubDate: string;
  tags?: ReadonlyArray<string>;
};

export function CardSmall({
  slug,
  heroImage,
  title,
  authorImage,
  author,
  pubDate,
  heroImageAlt,
}: Props) {
  return (
    <a
      target='_blank'
      href={normalizeCanonicalUrl(`/blog/${slug}`)}
      className='inline-flex w-full flex-wrap items-center justify-start gap-6'
    >
      <img
        alt={heroImageAlt ?? undefined}
        className='size-[96px] rounded-2xl object-cover sm:size-[122px]'
        height={122}
        src={heroImage ?? undefined}
        width={122}
      />
      <div className='inline-flex shrink grow basis-0 flex-col items-start justify-start gap-4'>
        <p className='self-stretch text-base leading-7 font-medium text-neutral-900'>
          {title}
        </p>
        <div className='inline-flex items-center justify-start gap-2'>
          <img
            alt={author}
            className='size-[26px] rounded-full'
            height={26}
            src={authorImage ?? undefined}
            width={26}
          />
          <p className='text-xs leading-3 font-medium text-neutral-500'>
            {author}
          </p>
          <p className='text-xs leading-3 font-medium text-neutral-500'>•</p>
          <p className='text-xs leading-3 font-normal text-neutral-500'>
            <FormattedDate date={pubDate} />
          </p>
        </div>
      </div>
    </a>
  );
}
